import { Outlet } from "react-router-dom"
import AdminNavbar from "./AdminNavbar"

export default function AdminLayout({children}){
return(
<div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-cyan-900">
    <AdminNavbar/>
    <Outlet/>
    
    <main className="p-4">
        {children}
    </main>
    
    {/* Footer */}
    <div className="text-center py-4 text-white/50 text-sm border-t border-white/10">
      🦈 Blue Shark Admin Dashboard © 2026
    </div>
</div>
)
}